import React from "react";
import { ArrowUpRight } from "lucide-react";
import { getContrastTextColor } from "@/lib/utils";

interface MarketingFooterProps {
  meetingLinkId: string;
  backgroundUrl?: string;
  text?: string;
  textColor?: string;
  linkColor?: string;
}

export const MarketingFooter: React.FC<MarketingFooterProps> = ({
  meetingLinkId,
  backgroundUrl,
  text = "Calendar that aligns with your biological clock.",
  textColor,
  linkColor
}) => {
  const contrastColor = getContrastTextColor(backgroundUrl || '');
  const finalTextColor = textColor || contrastColor;
  const finalLinkColor = linkColor || contrastColor;
  return (
    <footer
      className="w-full p-0 pb-4 px-4 bg-white-100 text-center text-sm my-2 sm:my-0"
      style={{ color: finalTextColor }}
    >
      <div>
        <a
          href={`http://chronocal.io?utm_source=booking_page&utm_medium=footer&utm_campaign=meeting_links&utm_content=${meetingLinkId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold inline-flex flex-col md:flex-row mt-4 md:mt-0 items-center justify-center gap-2 mb-1"
          style={{ color: finalLinkColor }}
        >
          <img
            src="/assets/icons/branding/chronocal-logo.svg"
            alt="ChronoCal Logo"
            height={16}
            style={{ maxHeight: 16, marginRight: 2, marginTop: -3, verticalAlign: 'middle', display: 'flex-inline'}}
          />
          <span className="font-medium">{text}</span>
          <span className="font-bold inline-flex items-center gap-1">
            Get yours
            <ArrowUpRight className="w-4 h-4 mt-0.5" style={{ color: finalLinkColor }} aria-label="Opens in new tab" />
          </span>
        </a>
      </div>
    </footer>
  );
};

export default MarketingFooter;